import { Navigate } from "react-router";
import { useGetMembersGroupUserQuery } from "../../../apis/MembersGroupUser.api";
import { PrimaryMembersGroupUser, MembersGroupUser } from "../../../types/models/MembersGroupUser";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const MembersGroupUserScoped = () => {
    const {
        data,
    } = useGetMembersGroupUserQuery(PrimaryMembersGroupUser.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/members-group-users/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default MembersGroupUserScoped;
